var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('select-box',{staticClass:"select-box",attrs:{"category":_vm.category,"base-category":_vm.baseCategory},on:{"submit":_vm.submit}}),_c('prod-list',{ref:"prodList",attrs:{"category":_vm.category,"base-category":_vm.baseCategory,"conditions":_vm.conditions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }